import { PolyfazerEnv } from "../polyfazer/PolyfazerEnv";

export class RemotePolyfazerEnv extends PolyfazerEnv {
	static get environmentID() {
		return "polyfazer-remote";
	}

	get environmentName() {
		return "Remote Polyfazer";
	}

	get assetsEnvironment() {
		return PolyfazerEnv;
	}
}

new RemotePolyfazerEnv();
